import { Component } from '@angular/core';

@Component({
  selector: 'app-shift-summary-field-sources',
  standalone: true,
  templateUrl: './shift-summary-field-sources.component.html',
  styleUrls: ['./shift-summary-field-sources.component.css']
})
export class ShiftSummaryFieldSourcesComponent {
}
